import { Controls, Player } from '@lottiefiles/react-lottie-player';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAccessList, getMyAccessList, getOrganizationList } from '../../api/api.global';
import { postApi } from '../../api/call.api';
import { CHAT_DOMAIN, CHAT_DOMAIN_PROFILE } from '../../api/static.data.pnp';
import { urlApi } from '../../api/url.api';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { AUTO_LOGIN_TOKEN, PROFILE, USER_ID } from '../../statics/localStorage';
import { checkDomain } from '../../utils/domainCheck.util';
import { encryptLocalStorage } from '../../utils/localStorage.utils';
import { accessCheck } from '../../utils/accessCheck';
import { accessKeys } from '../../statics/accessKeys';

const SplashScreen = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const autoLoginId = AUTO_LOGIN_TOKEN();
    const userId = USER_ID();
    const profileData = PROFILE();

    encryptLocalStorage("advy-token", token);

    async function autoLogin() {
        if (!autoLoginId || !userId) {
            return;
        }
        let postData = {
            userId: userId,
            autoLoginId: autoLoginId,
            signUpDomain: checkDomain()
        }
        loadingShow();
        let resp = await postApi(postData, urlApi.autoLogin);
        loadingHide();
        if (resp.responseCode === 200) {
            await getMyAccessList();
            await getAccessList();
            encryptLocalStorage('advy-a-l-t', resp?.data?.autoLoginId);
            encryptLocalStorage("profile", resp.data);
            getOrganizationList();
            if (checkDomain() === "chat") {
                if (resp?.data?.updatedOrganizationDetailsForChat == 1) {
                    if (accessCheck(accessKeys?.createAndUpdateChatSession)) {
                        window.location.replace(CHAT_DOMAIN);
                    } else {
                        window.location.replace(CHAT_DOMAIN_PROFILE)
                    }
                    return;
                } else {
                    navigate("/organization-form", { replace: true });
                    return;
                }
            }
            if (checkDomain() === "app") {
                navigate('/dashboard', { replace: true });
            }
        } else {
            navigate("/login", { replace: true })
        }
    }

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (searchParams.get('token')) {
                if (checkDomain() === "chat") {
                    if (profileData?.updatedOrganizationDetailsForChat == 1) {
                        if (accessCheck(accessKeys?.createAndUpdateChatSession)) {
                            window.location.replace(CHAT_DOMAIN);
                        } else {
                            window.location.replace(CHAT_DOMAIN_PROFILE)
                        }
                        return;
                    } else {
                        navigate("/organization-form", { replace: true });
                        return;
                    }
                }
                if (checkDomain() === "app") {
                    navigate('/dashboard', { replace: true });
                }
            } else if (autoLoginId && userId) {
                autoLogin();
            } else {
                navigate("/login", { replace: true })
            }
        }, 3000);
        return () => {
            clearTimeout(timeout);
        }
    }, [token])


    return (
        <div className='flex items-center justify-center h-screen'>
            <Player src={process.env.PUBLIC_URL + "/loading/loading-text.json"} background="rgba(0, 0, 0, 0)" speed="1" loop autoplay style={{ height: 300 }}>
                <Controls visible={false} />
            </Player>
        </div>
    )
}

export default SplashScreen